import React from 'react'

import { Player } from 'video-react'

import {
    EuiText,
    EuiIcon,
    EuiPanel
  } from '@elastic/eui'

import { OutboundLink } from 'gatsby-plugin-gtag'

require('../../Layout/chrome/assets/video.css')

function VideoCard() {
  return (
    <EuiPanel paddingSize="m">
        <Player>
            <source src="https://wiki.instar.com/videos/INSTAR_Cloud_So_erstellen_Sie_einen_neuen_Account_und_fuegen_die_ersten_Kamera_hinzu.mp4" />
        </Player>
        <EuiText>
            <p>In diesem Video zeigen wir Ihnen wie Sie bei der INSTAR Cloud Plattform einen Account erstellen und eine IP Kamera hinzufügen um die Aufnahmen dann online sicher abzuspeichern. Auf <OutboundLink href="https://www.youtube.com/watch?v=O5wrWGLIk0k" target="_blank" rel="noopener noreferrer">Youtube ansehen <EuiIcon type="popout" /></OutboundLink></p>
        </EuiText>
    </EuiPanel>
  );
}

export default VideoCard